import AdminAuth from '@/libs/admin-auth'
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    user: null,
  },
  getters: {
    isAuthenticated: state => !!state.user,
    getLoggedUser: state => state.user,
  },
  mutations: {
    SET_USER: (state, user) => {
      state.user = user
    },
  },
  actions: {
    async fetchUserData() {
      const userData = await axiosIns.get('/auth')
      return userData.data.data
    },
    async authenticateUser({ commit, dispatch }, { username, password }) {
      const adminAuth = new AdminAuth()
      const result = await adminAuth.authenticateUser(username, password)
      let userData = null
      if (result.authenticated) {
        const { user } = result
        if (user.challengeName !== 'NEW_PASSWORD_REQUIRED') {
          userData = await dispatch('fetchUserData')
        }
        commit('SET_USER', user)
      }
      return {
        authenticated: result.authenticated,
        user: result.user,
        userData,
      }
    },
    async updatePassword({ commit, state, dispatch }, newPassword) {
      const adminAuth = new AdminAuth()
      const user = await adminAuth.updatePassword(state.user, newPassword)
      const userData = await dispatch('fetchUserData')
      commit('SET_USER', user)
      return userData
    },
    async currentSession({ commit }) {
      const adminAuth = new AdminAuth()
      await adminAuth.currentSession()
      const user = await adminAuth.currentAuthenticatedUser()
      if (user?.storage?.userData) {
        commit('SET_USER', JSON.parse(user?.storage?.userData))
      } else {
        commit('SET_USER', user)
      }
    },
    async signOut({ commit }) {
      const adminAuth = new AdminAuth()
      await adminAuth.signOut()
      commit('SET_USER', null)
      localStorage.removeItem('userData')
    },
  },
}
